import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import PageHero from "../../components/PageHero";
import Pagination from "../../components/Pagination";

export default function News({ siteContent }) {
  const { title, headContent, image, news, slug } = siteContent;
  const NEWS = news;
  const history = useHistory();

  const ordered = useMemo(
    () => [...NEWS].sort((a, b) => new Date(b.date) - new Date(a.date)),
    [],
  );

  const perPage = 6;
  const totalPages = Math.max(1, Math.ceil(ordered.length / perPage));
  const [page, setPage] = useState(1);

  const start = (page - 1) * perPage;
  const items = ordered.slice(start, start + perPage);

  const open = (id) => history.push(`/${slug}/${id}`);

  return (
    <>
      <PageHero title={title} subtitle={headContent} img={image?.url} />

      <main className="container main">
        <section className="section">
          <div className="newsGrid">
            {items.map((n) => (
              <article className="ncard" key={n.id}>
                {/* opcional: se você tiver cover */}
                {n.image && (
                  <button
                    className="ncard__media"
                    type="button"
                    onClick={() => open(n.id)}
                  >
                    <img src={n.image.url} alt={n.title} loading="lazy" />
                  </button>
                )}

                <div className="ncard__body">
                  <div className="ncard__flex">
                    <div className="ncard__meta">
                      {n.important && <span className="badge">Importante</span>}
                      <span className="date">
                        {n.date.split("-").reverse().join("-")}
                      </span>
                    </div>
                    <h3 className="ncard__title">{n.title}</h3>
                    <p className="ncard__text">{n.subtitle}</p>
                  </div>

                  <button
                    className="btn btn--ghost"
                    type="button"
                    onClick={() => open(n.id)}
                  >
                    LEIA MAIS
                  </button>
                </div>
              </article>
            ))}
          </div>

          <Pagination page={page} totalPages={totalPages} onChange={setPage} />
        </section>
      </main>
    </>
  );
}
